import React, { useState } from "react";
import "./Navbar.css";

const Action = {
  HOME: "Home",
  ABT: "About Me",
  RES: "Resume",
  TES: "Testimonial",
  CNT: "Contact Me",
};

export default function Navbar() {
  const [state, setState] = useState(Action.HOME);
  const [toggle, setToggle] = useState(false);
  const onToggle = () => {
    setToggle(!toggle);
    onclickfunc(state);
  };
  const onclickfunc = (action) => {
    switch (action) {
      case Action.HOME:
        setState(Action.HOME);
        break;
      case Action.ABT:
        setState(Action.ABT);
        break;
      case Action.RES:
        setState(Action.RES);
        break;
      case Action.TES:
        setState(Action.TES);
        break;
      case Action.CNT:
        setState(Action.CNT);
        break;
      default:
        break;
    }
  };
  return (
    <nav className="nav">
      <a href="/" className="site-title">
        Portfolio
      </a>

      <a
        href={"#" + state}
        onClick={() => {
          onToggle();
        }}
        className="toggle-button"
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </a>
      <ul className={toggle ? "active" : ""}>
        <li
          onClick={() => {
            onclickfunc(Action.HOME);
          }}
          className={Action.HOME === state ? "active" : ""}
        >
          <a href="#Home">Home</a>
        </li>
        <li
          onClick={() => {
            onclickfunc(Action.ABT);
          }}
          className={Action.ABT === state ? "active" : ""}
        >
          <a href="#AboutMe">About Me</a>
        </li>
        <li
          onClick={() => {
            onclickfunc(Action.RES);
          }}
          className={Action.RES === state ? "active" : ""}
        >
          <a href="#Resume">Resume</a>
        </li>
        <li
          onClick={() => {
            onclickfunc(Action.TES);
          }}
          className={Action.TES === state ? "active" : ""}
        >
          <a href="#Testimonial">Testimonial</a>
        </li>
        <li
          onClick={() => {
            onclickfunc(Action.CNT);
          }}
          className={Action.CNT === state ? "active" : ""}
        >
          <a href="#ContactMe">Contact Me</a>
        </li>
      </ul>
    </nav>
  );
}
